export class GetFeatureToggles {
  static readonly type = "[FeatureToggle] Get Feature Toggles";
  constructor() {}
}
